export default "__VITE_ASSET__CXv$OqY0__"